// @flow

import nightlyRates from './nightly-rates'

export default nightlyRates
